export const end_type = 0;
export const inactive_coils = 1;
export const add_coils_solid = 2;
